var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoalBurned({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "28px",
    viewBox: "0 0 44 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/coal-burned") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Impact",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Impact-Section",
    transform: "translate(-345.000000, -618.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Content",
    transform: "translate(267.500000, 142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wide-Card",
    transform: "translate(0.000000, 375.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Large-Statistic",
    transform: "translate(77.500000, 92.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/coal-burned",
    transform: "translate(0.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DFEDEB",
    fillRule: "nonzero",
    points: "32.3841778 2.03776084 37.2448862 3.60139715 39.5354632 7.65204322 32.3841778 6.72970051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6409906,8.36600416 L39.9492521,9.43754684 L38.7640886,12.6505429 L38.0521827,12.0361345 C37.8961203,11.9014508 37.6967454,11.8273232 37.4905814,11.8273232 L29.8101791,11.8273232 C29.6004917,11.8273232 29.398023,11.9039418 29.2409294,12.0427484 L28.4112891,12.7759499 L26.1253528,10.6356991 L31.6409906,8.36600416 Z",
    id: "Path",
    fill: "#9FD4CD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#9FD4CD",
    fillRule: "nonzero",
    points: "27.1180164 13.9189574 23.5255729 17.0936441 25.0020643 11.9378704"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DFEDEB",
    fillRule: "nonzero",
    points: "24.3219553 3.90855841 30.6654286 2.01242176 30.6654286 6.90973686 24.3929396 9.49088777 20.7012384 9.49088777"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DFEDEB",
    fillRule: "nonzero",
    points: "7.02334686 14.3804723 10.459642 14.6781851 13.6852185 18.4762992 8.32933839 19.8812871 4.93377761 16.1184759"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#9FD4CD",
    fillRule: "nonzero",
    points: "1.82782606 21.6436849 3.89917657 17.5367775 6.9477219 20.91495 3.83953598 25.3993669"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#50BAB5",
    fillRule: "nonzero",
    points: "12.6829299 26.1845349 5.38615238 26.1845349 8.56712733 21.5950682 14.0686714 20.151857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0086646,13.8474926 L16.8814903,9.52043572 L19.5381608,11.0893116 C19.6705905,11.1674763 19.8214966,11.2087919 19.9753247,11.2087919 L23.4231354,11.2087919 L21.3027146,18.6128726 L14.2550698,16.4925495 L12.0086646,13.8474926 Z",
    id: "Path",
    fill: "#DFEDEB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4463665,26.1845349 L16.0614751,19.1528958 C16.0858813,19.0466434 16.0885454,18.9385013 16.0728188,18.8334515 L21.2378318,20.3873817 L23.4642135,26.1846208 L14.4463665,26.1846208 L14.4463665,26.1845349 Z",
    id: "Path",
    fill: "#50BAB5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#50BAB5",
    fillRule: "nonzero",
    points: "25.1523689 25.7863248 22.9051904 19.9349716 29.5488433 14.0638626 32.5934355 20.0255052"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#9FD4CD",
    fillRule: "nonzero",
    points: "34.1262159 19.2484112 31.2137096 13.5453991 37.1708941 13.5453991 41.375642 17.1739562"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    fill: "#50BAB5",
    points: "26.1253528 27.1823116 33.6522642 20.151857 43.053317 17.5367775 43.053317 24.1387891 39.9492521 27.1823116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7022267,16.9119758 L40.1536113,13.8496399 L41.934837,9.02061152 C42.0221494,8.78379844 42.0009229,8.52061553 41.8766573,8.3008097 L38.5758856,2.46380106 C38.4696669,2.27594825 38.2965888,2.13499422 38.0910264,2.06876901 L31.7880296,0.041298599 C31.622686,-0.0118705327 31.4449673,-0.0137602272 31.2785064,0.0359730963 L23.5265182,2.35316804 C23.3310105,2.41166267 23.162659,2.53767094 23.0516278,2.70894598 L19.0841533,8.82588709 L17.2162167,7.72282087 C16.8948106,7.53290657 16.4874671,7.57241837 16.2082563,7.82022603 L10.4300795,12.951262 L6.81941728,12.6384317 C6.59374552,12.619277 6.36953469,12.6892816 6.19551135,12.8339291 L3.14679414,15.3697274 C3.05621606,15.4450575 2.98213797,15.5381679 2.92911456,15.6433895 L0.0919753758,21.26901 C-0.0340089353,21.5187933 -0.0303995622,21.8143587 0.101772246,22.0610497 L2.98772391,27.4489123 C3.13725508,27.7281577 3.42841119,27.902439 3.74534852,27.902439 L29.1189841,27.902439 C29.5936167,27.902439 29.9783587,27.5178003 29.9783587,27.043487 C29.9783587,26.5691737 29.5936167,26.1845349 29.1189841,26.1845349 L27.4447506,26.1845349 L34.078005,21.0490324 L42.2812509,18.7015165 L42.2812509,23.4687003 L39.4169554,26.184449 L36.8382302,26.184449 C36.3635976,26.184449 35.9788556,26.5690878 35.9788556,27.0434011 C35.9788556,27.5177144 36.3635976,27.902439 36.8382302,27.902439 L39.759674,27.902439 C39.9797598,27.902439 40.1914238,27.818004 40.3510956,27.6665708 L43.732047,24.4610476 C43.9030625,24.2988775 44,24.0735744 44,23.8378779 L44,17.5622025 C44,17.3124192 43.8912891,17.0751767 43.7022267,16.9119758 L43.7022267,16.9119758 Z M32.3841778,2.03776084 L37.2448862,3.60139715 L39.5354632,7.65204322 L32.3841778,6.72970051 L32.3841778,2.03776084 Z M31.6409906,8.36600416 L39.9492521,9.43754684 L38.7640886,12.6505429 L38.0521827,12.0361345 C37.8961203,11.9014508 37.6967454,11.8273232 37.4905814,11.8273232 L29.8101791,11.8273232 C29.6004917,11.8273232 29.398023,11.9039418 29.2409294,12.0427484 L28.4112891,12.7759499 L26.1253528,10.6356991 L31.6409906,8.36600416 Z M27.1180164,13.9189574 L23.5255729,17.0936441 L25.0020643,11.9378704 L27.1180164,13.9189574 Z M24.3219553,3.90855841 L30.6654286,2.01242176 L30.6654286,6.90973686 L24.3929396,9.49088777 L20.7012384,9.49088777 L24.3219553,3.90855841 Z M7.02334686,14.3804723 L10.459642,14.6781851 L13.6852185,18.4762992 L8.32933839,19.8812871 L4.93377761,16.1184759 L7.02334686,14.3804723 Z M1.82782606,21.6436849 L3.89917657,17.5367775 L6.9477219,20.91495 L3.83953598,25.3993669 L1.82782606,21.6436849 Z M12.6829299,26.1845349 L5.38615238,26.1845349 L8.56712733,21.5950682 L14.0686714,20.151857 L12.6829299,26.1845349 Z M12.0086646,13.8474926 L16.8814903,9.52043572 L19.5381608,11.0893116 C19.6705905,11.1674763 19.8214966,11.2087919 19.9753247,11.2087919 L23.4231354,11.2087919 L21.3027146,18.6128726 L14.2550698,16.4925495 L12.0086646,13.8474926 Z M14.4463665,26.1845349 L16.0614751,19.1528958 C16.0858813,19.0466434 16.0885454,18.9385013 16.0728188,18.8334515 L21.2378318,20.3873817 L23.4642135,26.1846208 L14.4463665,26.1846208 L14.4463665,26.1845349 Z M25.1523689,25.7863248 L22.9051904,19.9349716 L29.5488433,14.0638626 L32.5934355,20.0255052 L25.1523689,25.7863248 Z M34.1262159,19.2484112 L31.2137096,13.5453991 L37.1708941,13.5453991 L41.375642,17.1739562 L34.1262159,19.2484112 Z",
    id: "Shape",
    fill: "#1A2C3B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#1A2C3B",
    fillRule: "nonzero",
    cx: 33.2682927,
    cy: 26.902439,
    r: 1.07317073
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoalBurned);
export default __webpack_public_path__ + "static/media/coal-burned.8f38c26ee06fc9a456e6fc41dbd2946e.svg";
export { ForwardRef as ReactComponent };